import React from 'react'
import { OpportunityNewsProps, CMSSectionBase } from '../../../lib/types'
import { CMSLeadershipTeam } from './cms-leadership-team'
import { getCMSSectionTitle } from './cms-section-config'
import {
  CmsSectionTextColorProvider,
  getCmsSectionShellClassName,
  getCmsSectionShellStyle,
  resolveCmsSectionBackgroundHex,
} from './cms-section-text-content'
import { OPPORTUNITY_SECTION_IDS } from '../opportunity-detail.utils'

const OpportunityDetailLeadershipTeam = ({ opportunityDetails }: OpportunityNewsProps) => {
  const team = opportunityDetails?.leadershipTeam
  const hasMembers = Boolean(team?.teamMembers?.length)
  const hasText = Boolean(team?.text?.length)
  const backgroundColor = resolveCmsSectionBackgroundHex(team)

  if (!team?.showSection || (!hasMembers && !hasText)) {
    return null
  }

  const heading = getCMSSectionTitle(
    'leadershipTeam',
    team as CMSSectionBase & { sectionTitle?: string },
  )

  return (
    <section
      id={OPPORTUNITY_SECTION_IDS.leadership}
      className={getCmsSectionShellClassName(
        'opportunity-overview-panel opportunity-cms-section-card opportunity-news-card',
        backgroundColor,
      )}
      style={getCmsSectionShellStyle(backgroundColor)}
      data-testid='opportunity-leadership-team-section'
    >
      <header className='opportunity-news-header'>
        <h2 className='opportunity-cms-section-title h5-heading' data-testid='cms-leadership-team'>
          {heading}
        </h2>
      </header>

      <CmsSectionTextColorProvider backgroundColor={backgroundColor}>
        <div className='opportunity-team-section-body opportunity-cms-section-body'>
          <CMSLeadershipTeam leadershipTeam={team} />
        </div>
      </CmsSectionTextColorProvider>
    </section>
  )
}

export default OpportunityDetailLeadershipTeam
